module.exports = __webpack_public_path__ + "media/flags/019-france-f497bfed.svg";